<div class="ec-editor-container" xmlns="http://www.w3.org/1999/html">
    <div class="app-dialog-background app-dialog-padding">
        <form [formGroup]="form1">
            <div fxLayout="column" fxLayoutGap="20px">
                <!-- NAME -->
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Name'|i18n) + ':*' }}</div>
                    <div fxFlex app-input-container>
                        <input class="input-font"
                               app-input
                               [maxLength]="ENTITY_NAME_MAX_LENGTH"
                               placeholder="{{'Name'|i18n}}"
                               formControlName="ecName">
                        <div *ngIf="nameError === 'duplicate'" app-error>
                            {{ 'Resource {0} already exists'|i18n:form1.controls.ecName.value.trim() }}
                        </div>
                        <div *ngIf="nameError === 'pattern'" app-error>
                            {{ 'Characters {0} are invalid'|i18n:nameForbiddenCharacters }}
                        </div>
                        <div *ngIf="!this.form1.controls.ecName.pristine && nameError === 'invalid'" app-error>
                            {{ 'Invalid name'|i18n }}
                        </div>
                    </div>
                    <div fxFlex="20"></div>
                </div>
                <!--SUBTYPE-->
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Type'|i18n) + ':*' }}</div>
                    <div fxFlex app-input-container>
                        <mat-select app-small-select
                                    [disabled]="true"
                                    [placeholder]="'Type'|i18n"
                                    formControlName="subType">
                            <mat-option [value]="EntitySubType.RENEWABLE_ENERGY_COMMUNITY">
                                {{
                                    {
                                        type: EntityType.ENERGY_COMMUNITY,
                                        sub_type: EntitySubType.RENEWABLE_ENERGY_COMMUNITY
                                    }|entityType|i18n
                                }}
                            </mat-option>
                            <mat-option [value]="EntitySubType.COLLECTIVE_SELF_CONSUMPTION_GROUP">
                                {{
                                    {
                                        type: EntityType.ENERGY_COMMUNITY,
                                        sub_type: EntitySubType.COLLECTIVE_SELF_CONSUMPTION_GROUP
                                    }|entityType|i18n
                                }}
                            </mat-option>

                        </mat-select>
                    </div>
                    <div fxFlex="20"></div>
                </div>
                <app-divider></app-divider>

                <!-- ACTIVATION DATE -->
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end"
                         fxFlex="30">{{ ('Activation date'|i18n) + ':' }}
                    </div>
                    <div fxFlex app-input-container *ngIf="this.form1.controls.activationDate.value">
                        <input class="input-font"
                               app-input
                               [readonly]="true"
                               fxFlex="90"
                               placeholder="{{'Activation date'|i18n}}"
                               [matDatepicker]="activationDate"
                               formControlName="activationDate">
                        <div *ngIf="!this.form1.controls.activationDate.pristine && this.form1.controls.activationDate.invalid"
                             app-error>
                            {{ 'Invalid date'|i18n }}
                        </div>
                        <mat-datepicker-toggle [for]="activationDate"></mat-datepicker-toggle>
                        <mat-datepicker #activationDate disabled="true"></mat-datepicker>
                        <button app-ghost-button (click)="resetActivationDate()" *ngIf="!activationDateReadonly">
                            <app-icon class="app-icon-right" name="fal-calendar-alt"></app-icon>&nbsp;
                            {{ 'Reset date'|i18n }}
                        </button>
                    </div>
                    <div fxFlex app-input-container
                         *ngIf="!this.form1.controls.activationDate.value && !activationDateReadonly">
                        <button app-ghost-button (click)="openActivationDateDialog()">
                            {{ 'Insert date'|i18n }}
                            &nbsp;<app-icon class="app-icon-right" name="fal-calendar-alt"></app-icon>
                        </button>
                    </div>
                    <div fxFlex="20"></div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" class="mt-10">
                    <div fxFlex="26"></div>
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="info-panel">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <app-icon name="fas-info-circle"></app-icon>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="start start">
                            <div>
                                {{ 'GSE defined date.'|i18n }}
                            </div>
                            <div>
                                {{ 'Energy data and incentives will be accounted for from this date.'|i18n }}
                            </div>
                        </div>
                    </div>
                </div>
                <app-divider></app-divider>
                <div fxLayout="row" class="txt-h-18-7">{{ 'Geographical position'|i18n }}</div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Office address'|i18n) + ':*' }}</div>
                    <div fxFlex>
                        <app-google-maps-address-autocomplete [formControlRef]="addressFormControl"
                                                              (addressChange)="addressChange($event)"
                                                              [restrictSearch]="true">
                        </app-google-maps-address-autocomplete>
                    </div>
                    <div fxFlex="20"></div>
                </div>
            </div>
        </form>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" class="mt-20">
        <div fxFlex>
            <button app-ghost-button (click)="cancel()">
                {{ 'Cancel'|i18n }}
            </button>
        </div>
        <div fxFlex>&nbsp;</div>
        <div>
            <button app-primary-button (click)="saveAction()" [disabled]="!form1.valid">
                {{ 'Save'|i18n }}
            </button>
        </div>
    </div>

    <ng-template #selectActivationDate let-data let-close="close">
        <div class="select-activation-date">

            <app-activation-date-dialog (activationDateEmitter)="data.ad = $event"
                                        [currentActivationDate]="data.currentActivationDate">

            </app-activation-date-dialog>
            <div class="dialog-actions mt-16" fxLayout="row" fxLayoutAlign="center">
                <div fxLayout="row" fxLayoutAlign="start center" class="mt-20">
                    <div>
                        <button app-ghost-button
                                (click)="selectActivationDateEvent(null, close)">
                            {{ 'Cancel'|i18n }}
                        </button>
                    </div>
                    <div fxFlex>&nbsp;</div>
                    <div>
                        <button app-primary-button [disabled]="!data.ad"
                                (click)="selectActivationDateEvent(data.ad, close)">
                            {{ 'Confirm date'|i18n }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>


<ng-template #updatePod let-close="close" let-data>
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 txt-a-18-7">
        {{ 'Warning: the date applied to the PODs will not be editable'|i18n }}
    </div>
    <div class="ml-42 mr-42 mt-20 t-center">
        {{ ('Your CER is activated on date'|i18n) + ' ' }}<strong>{{ data.activationDate|i18nDate }}</strong>.
    </div>
    <div class="ml-42 mr-42 t-center">
        {{ 'If you wish, you can also apply this date to existing PODs, or fill it in manually for each one.'|i18n }}
    </div>
    <div class="ml-42 mr-42 mt-20 t-center">
        {{ 'Remember that the activation date of a POD regulates the attribution of the economic amount.'|i18n }}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-around" app-dialog-actions>
        <button app-ghost-button (click)="closePodUpdateAction(false, close)">
            {{ 'Do not apply'|i18n }}
        </button>
        <button app-primary-button (click)="closePodUpdateAction(true, close)">
            {{ 'Yes, apply'|i18n }}
        </button>
    </div>
</ng-template>
